import React from 'react'
import './hero.css'
export default function Hero() {
    return (
        <div className='hero-container'>
            <div className="hero-text">
                <h1>Reinvent Your Banking Experience with FinFlex</h1>
                <p>A smarter, faster, and more personalized way to manage your money. Join the waitlist today and be the first to experience banking redefined.</p>
                <div className="download-options">
                    <div className="playstore">
                        <i class='bx bxl-play-store' ></i>
                        <div className="download-text">
                            <p></p>
                            <p className="download-main">PlayStore</p>
                        </div>
                    </div>
                    <div className="applestore">
                        <i class='bx bxl-apple' ></i>
                        <div className="download-text">
                            <p></p>
                            <p className="download-main">AppleStore</p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="hero-image">
                <img src="assets/iPhone_15_Mockup__Perspective-removebg-preview.png" alt="Hero-image" />
            </div>
        </div>
    )
}
